import React, { useState } from 'react';
import { customerService } from '../../services/customerService';
import { vehicleService } from '../../services/vehicleService';
import { partService } from '../../services/partService';
import * as XLSX from 'xlsx';

const ExcellImport = () => {
  const [target, setTarget] = useState('E2B_PARTS'); // 부품 화면으로 기본값
  const [status, setStatus] = useState('');
  const [loading, setLoading] = useState(false);

  const formatExcelDate = (val) => {
    if (!val) return "";
    if (typeof val === 'string' && val.includes('-')) return val.trim();
    if (!isNaN(val) && String(val).length > 3) {
      const date = new Date((val - 25569) * 86400 * 1000);
      return date.toISOString().split('T')[0];
    }
    return String(val).trim();
  };

  const cleanData = (item) => {
    const cleaned = {};
    Object.keys(item).forEach(key => {
      const newKey = key.replace(/^\ufeff/g, '').trim();
      let val = item[key];
      const dateFields = ['customsDate', 'deliveryDate', 'warrantyExpiry'];
      const numberFields = ['warrantyYears', 'stock', 'purchasePrice', 'outgoingPrice', 'consumerPrice', 'importCost'];
      
      if (dateFields.includes(newKey)) cleaned[newKey] = formatExcelDate(val);
      else if (numberFields.includes(newKey)) cleaned[newKey] = Number(String(val || 0).replace(/[^0-9.-]/g, '')) || 0;
      else cleaned[newKey] = typeof val === 'string' ? val.trim() : val;
    });
    return cleaned;
  };

  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setLoading(true);
    const reader = new FileReader();
    reader.onload = async (event) => {
      try {
        const data = new Uint8Array(event.target.result);
        const workbook = XLSX.read(data, { type: 'array' });
        const jsonData = XLSX.utils.sheet_to_json(workbook.Sheets[workbook.SheetNames[0]]);
        await processImport(jsonData);
      } catch (err) { alert("에러: " + err.message); } finally { setLoading(false); }
    };
    reader.readAsArrayBuffer(file);
  };

  const processImport = async (newData) => {
    let count = 0;
    try {
      for (const raw of newData) {
        const item = cleanData(raw);
        if (target === 'E2B_CUSTOMERS') await (customerService.addCustomer ? customerService.addCustomer(item) : customerService.saveCustomer(null, item));
        else if (target === 'E2B_VEHICLES') await (vehicleService.addVehicle ? vehicleService.addVehicle(item) : vehicleService.saveVehicle(null, item));
        else if (target === 'E2B_PARTS') await (partService.addPart ? partService.addPart(item) : partService.savePart(null, item));
        count++;
      }
      setStatus(`${count}건의 데이터가 업로드되었습니다.`);
      alert("✅ 업로드 성공!");
    } catch (e) { alert("오류: " + e.message); }
  };

  // 🚀 [추가된 기능] 잘못 올라간 SW40 부품만 찾아서 일괄 삭제
  const handleClearSW40 = async () => {
    if (!window.confirm('잘못 올라간 SW40 부품 데이터만 일괄 삭제하시겠습니까? (E6 데이터는 안전합니다)')) return;
    setLoading(true);
    try {
      const list = await partService.getParts();
      // modelName이 'SW40'인 데이터만 골라냅니다.
      const sw40Parts = list.filter(item => item.modelName === 'SW40');
      let count = 0;
      for (const item of sw40Parts) {
        await partService.deletePart(item.id);
        count++;
      }
      setStatus(`잘못 업로드된 SW40 데이터 ${count}건이 깔끔하게 삭제되었습니다.`);
      alert(`🔥 SW40 데이터 ${count}건 삭제 완료!`);
    } catch (e) { alert("삭제 실패: " + e.message); }
    setLoading(false);
  };

  const handleClearData = async () => {
    if (!window.confirm(`[${target}]의 모든 데이터를 삭제하시겠습니까?`)) return;
    setLoading(true);
    try {
      let list = (target === 'E2B_CUSTOMERS') ? await customerService.getCustomers() : (target === 'E2B_VEHICLES') ? await vehicleService.getVehicles() : await partService.getParts();
      for (const item of list) {
        if (target === 'E2B_CUSTOMERS') await customerService.deleteCustomer(item.id);
        else if (target === 'E2B_VEHICLES') await vehicleService.deleteVehicle(item.id);
        else if (target === 'E2B_PARTS') await partService.deletePart(item.id);
      }
      setStatus("데이터 삭제가 완료되었습니다.");
      alert("🔥 삭제 완료");
    } catch (e) { alert("삭제 실패"); }
    setLoading(false);
  };

  const style = {
    wrapper: { padding: '40px 100px', background: '#f8fafc', minHeight: '100vh' },
    card: { background: 'white', padding: '35px', borderRadius: '20px', boxShadow: '0 4px 25px rgba(0,0,0,0.05)', marginBottom: '30px' },
    input: { width: '100%', padding: '12px', border: '1px solid #e2e8f0', borderRadius: '10px', boxSizing: 'border-box', outline: 'none' },
    label: { fontSize: '12px', fontWeight: 'bold', color: '#475569', marginBottom: '8px', display: 'block' },
    btnDanger: { padding: '12px 24px', background: '#ef4444', color: 'white', border: 'none', borderRadius: '10px', cursor: 'pointer', fontWeight: 'bold' },
    infoCard: { background: '#fffbeb', padding: '25px', borderRadius: '20px', border: '1px solid #fef3c7' }
  };

  return (
    <div style={style.wrapper}>
      <div style={style.card}>
        <h2 style={{ margin: '0 0 10px 0' }}>📥 초기 데이터 일괄 임포트 (Excel)</h2>
        <p style={{ color: '#64748b', marginBottom: '30px' }}>엑셀 파일을 사용하여 클라우드 데이터베이스를 구축합니다.</p>

        <div style={{ background: '#f8fafc', padding: '30px', borderRadius: '15px', border: '1px solid #f1f5f9' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', marginBottom: '30px' }}>
            <div style={{ flex: 1, marginRight: '20px' }}>
              <label style={style.label}>1. 데이터 저장 위치 선택</label>
              <select style={style.input} value={target} onChange={(e) => setTarget(e.target.value)}>
                <option value="E2B_CUSTOMERS">👥 고객 관리 (Customers)</option>
                <option value="E2B_VEHICLES">🚗 차량 마스터 (Vehicles)</option>
                <option value="E2B_PARTS">⚙️ 부품 마스터 (Parts)</option>
              </select>
            </div>
            {/* 🚀 타겟이 부품(E2B_PARTS)일 때만 주황색 SW40 청소 버튼 노출 */}
            {target === 'E2B_PARTS' && (
              <button onClick={handleClearSW40} type="button" style={{...style.btnDanger, background: '#f59e0b', marginRight: '10px'}}>
                🧹 SW40만 삭제
              </button>
            )}
            <button onClick={handleClearData} type="button" style={style.btnDanger}>전체 데이터 삭제</button>
          </div>

          <div>
            <label style={style.label}>2. 엑셀 파일 업로드</label>
            <input type="file" accept=".xlsx, .xls, .csv" onChange={handleFileUpload} style={{ ...style.input, background: 'white' }} />
          </div>
        </div>

        {loading && <p style={{ color: '#3b82f6', marginTop: '20px', fontWeight: 'bold' }}>⏳ 처리 중입니다. 잠시만 기다려주세요...</p>}
        {status && <div style={{ marginTop: '25px', color: '#16a34a', fontWeight: 'bold' }}>✅ {status}</div>}
      </div>

      <div style={style.infoCard}>
        <h4 style={{ margin: '0 0 10px 0', color: '#92400e' }}>💡 업로드 전 확인사항</h4>
        <ul style={{ fontSize: '13px', color: '#b45309', lineHeight: '1.8', margin: 0, paddingLeft: '20px' }}>
          <li>각 카테고리에 맞는 <b>표준 영문 헤더</b>를 포함한 파일을 사용해 주세요.</li>
          <li><b>중복 방지:</b> 기존 데이터를 모두 지우고 새로 올리려면 '전체 데이터 삭제'를 먼저 누르세요.</li>
          <li>업로드가 완료되면 해당 메뉴로 이동하여 데이터가 잘 들어왔는지 확인하세요.</li>
        </ul>
      </div>
    </div>
  );
};

export default ExcellImport;